export default __webpack_public_path__ + "static/media/formatEightPlaySelected.d387b888.svg";